import { Component } from '@angular/core';
import { PoBreadcrumb, PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { NotasFaturamentoService } from './notas-faturamento.service';

@Component({
  selector: 'app-notas-faturamento',
  templateUrl: './notas-faturamento.component.html',
  styleUrls: ['./notas-faturamento.component.css'],
  standalone: false
})
export class NotasFaturamentoComponent {

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', link: '/home' },
      { label: 'Financeiro' },
      { label: 'Notas e Faturamento' }
    ]
  };

  idEmpresa: number = 0;
  periodo: { start?: string; end?: string } = {};
  isLoading: boolean = false;

  constructor(
    private readonly notasFaturamentoService: NotasFaturamentoService,
    private readonly poDialogService: PoDialogService,
    private readonly poNotificationService: PoNotificationService
  ) { }

  /** Formata data para padrão US (YYYY-MM-DD) */
  formatDateUS(date: string | Date | undefined): string {
    if (!date) return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  requestNotasFaturamento(form: any) {
    if (!form.valid) {
      this.poNotificationService.warning('Preencha corretamente todos os campos obrigatórios.');
      return;
    }

    const dataDe = this.formatDateUS(this.periodo.start);
    const dataPara = this.formatDateUS(this.periodo.end);

    if (!dataDe || !dataPara) {
      this.poNotificationService.warning('Informe o período (data de início e data de fim).');
      return;
    }

    this.isLoading = true;
    this.notasFaturamentoService
      .requestNotasFaturamento(this.idEmpresa, dataDe, dataPara)
      .subscribe({
        next: () => {
          this.poDialogService.alert({
            title: 'Relatório - Notas e Faturamento',
            message: 'Relatório solicitado com sucesso. Dentro de instantes você receberá um e-mail com o relatório.'
          });
          form.reset();
          this.periodo = {};
        },
        error: () => {
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }
}
